import { IPalletListWithDetails } from '../../../../../../modules/API/Pallets/models/palletList'
import { IPutLocationData } from '../../../../../../modules/API/Pallets/models/locations'

/** A pallet number is valid when it is a positive integer. */
export const isValidPalletNumber = (value: string | number): boolean => {
  const num = Number(value)
  return Number.isInteger(num) && num > 0
}

/**
 * Build the payload for `Pallets.putPalletLocation`. For external pallets the
 * number goes into `ExtermalNum`, otherwise into `Pallet_Num` (mirrors legacy logic).
 */
export const buildLocationPayload = (
  pallet: IPalletListWithDetails,
  locationCode: string,
  isExternal: boolean,
): IPutLocationData => ({
  ExtermalNum: isExternal ? pallet.Pallet_Num : 0,
  Location: locationCode,
  Pallet_Num: isExternal ? 0 : pallet.Pallet_Num,
})

/** Build the payload for `Pallets.putCustomerToPallet`. */
export const buildCustomerPayload = (customer: { CustomerID: number }): { CustomerID: number } => ({
  CustomerID: customer.CustomerID || 0,
})

/** Build the payload for `Pallets.putPalletCoolingSite`. */
export const buildCoolingPayload = (site: { SiteID: number }): { KirurID: number } => ({
  KirurID: site.SiteID || 0,
})
